module.exports = __webpack_public_path__ + "img/2.2455a24f.png";